import useTrialExpired from 'hooks/stateHooks/useTrialExpired';
import React, { useMemo } from 'react';

import { AppLayoutContext } from '../../Contexts';
import useShowHeader from '../../hooks/useShowHeader';
import { ILayoutProvider } from '../../types';

/**
 * AppLayoutProvider - provides context determining when children should be
 * overridden for global purposes and navs disabled.
 * *
 *
 * Sidebar and Top navs will still be disabled where AppLayout determines
 * it.
 */
const AppLayoutProvider = ({ children }: ILayoutProvider): JSX.Element => {
  const showHeader = useShowHeader();
  const trialExpired = useTrialExpired();

  const value = useMemo(
    () => ({
      disableHeader: trialExpired,
      disableSidebar: false,
      showHeader,
    }),
    [showHeader, trialExpired],
  );

  return (
    <AppLayoutContext.Provider value={value}>
      {children}
    </AppLayoutContext.Provider>
  );
};

export default AppLayoutProvider;
